/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PeggedTokenBridge, PeggedTokenBridgeInterface } from "../PeggedTokenBridge";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract ISigsVerifier",
        name: "_sigsVerifier",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "burnId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "withdrawAccount",
        type: "address",
      },
    ],
    name: "Burn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "period",
        type: "uint256",
      },
    ],
    name: "DelayPeriodUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "threshold",
        type: "uint256",
      },
    ],
    name: "DelayThresholdUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "DelayedTransferAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "DelayedTransferExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "EpochLengthUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "cap",
        type: "uint256",
      },
    ],
    name: "EpochVolumeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "GovernorAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "GovernorRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MaxBurnUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MinBurnUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bytes32",
        name: "mintId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint64",
        name: "refChainId",
        type: "uint64",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "refId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "address",
        name: "depositor",
        type: "address",
      },
    ],
    name: "Mint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "PauserRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "addGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "addPauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_withdrawAccount",
        type: "address",
      },
      {
        internalType: "uint64",
        name: "_nonce",
        type: "uint64",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "delayPeriod",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "delayThresholds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "delayedTransfers",
    outputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "epochLength",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "epochVolumeCaps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "epochVolumes",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "id",
        type: "bytes32",
      },
    ],
    name: "executeDelayedTransfer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "governors",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "isGovernor",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "isPauser",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lastOpTimestamps",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "maxBurn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "minBurn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_request",
        type: "bytes",
      },
      {
        internalType: "bytes[]",
        name: "_sigs",
        type: "bytes[]",
      },
      {
        internalType: "address[]",
        name: "_signers",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_powers",
        type: "uint256[]",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "pausers",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    name: "records",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_account",
        type: "address",
      },
    ],
    name: "removeGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "removePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceGovernor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renouncePauser",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_period",
        type: "uint256",
      },
    ],
    name: "setDelayPeriod",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_thresholds",
        type: "uint256[]",
      },
    ],
    name: "setDelayThresholds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_length",
        type: "uint256",
      },
    ],
    name: "setEpochLength",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_caps",
        type: "uint256[]",
      },
    ],
    name: "setEpochVolumeCaps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "setMaxBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "_amounts",
        type: "uint256[]",
      },
    ],
    name: "setMinBurn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "sigsVerifier",
    outputs: [
      {
        internalType: "contract ISigsVerifier",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60a06040523480156200001157600080fd5b5060405162002d8b38038062002d8b83398101604081905262000034916200024f565b6200003f3362000074565b6000805460ff60a01b191690556200005733620000c4565b62000062336200018f565b6001600160a01b031660805262000281565b600080546001600160a01b038381166001600160a01b0319831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6001600160a01b03811660009081526001602052604090205460ff1615620001335760405162461bcd60e51b815260206004820152601960248201527f4163636f756e7420697320616c7265616479207061757365720000000000000060448201526064015b60405180910390fd5b6001600160a01b038116600081815260016020818152604092839020805460ff191690921790915590519182527f6719d08c1888103bea251a4ed56406bd0c3e69723c8a1686e017e7bbe159b6f891015b60405180910390a150565b6001600160a01b03811660009081526002602052604090205460ff1615620001fa5760405162461bcd60e51b815260206004820152601b60248201527f4163636f756e7420697320616c726561647920676f7665726e6f72000000000060448201526064016200012a565b6001600160a01b038116600081815260026020908152604091829020805460ff1916600117905590519182527fdc5a48d79e2e147530ff63ecdbed5a5a66adb9d5cf339384d5d076da197c40b5910162000184565b6000602082840312156200026257600080fd5b81516001600160a01b03811681146200027a57600080fd5b9392505050565b608051612ae7620002a46000396000818161051e01526114160152612ae76000f3fe608060405234801561001057600080fd5b506004361061025c5760003560e01c806382dc1ec411610145578063de790c7e116100bd578063eecdac881161008c578063f832138311610071578063f8321383146105d0578063f8734302146105f0578063f9a8ea081461060357600080fd5b8063eecdac88146105aa578063f2fde38b146105bd57600080fd5b8063de790c7e14610540578063e026049c14610553578063e3eece261461055b578063e43581b81461057e57600080fd5b8063adc0d57f11610114578063b5f2bc47116100f9578063b5f2bc47146104e6578063bf4816f014610506578063ccf2683b1461051957600080fd5b8063adc0d57f14610470578063b1c94d94146104dd57600080fd5b806382dc1ec41461041d5780638456cb59146104305780638da5cb5b146104385780639e25fc5c1461045d57600080fd5b806354eea796116101d85780636b2c0f55116101a7578063715018a61161018c578063715018a6146103d25780637f856013146103da57806380f51c12146103fa57600080fd5b80636b2c0f55146103b75780636ef8d66d146103ca57600080fd5b806354eea7961461036957806357d775f81461037c5780635c975abb1461038557806360216b001461039757600080fd5b80633f4ba83a1161022f57806347b16c6c1161021457806347b16c6c14610308578063497bf3b21461031b57806352532faa1461034957600080fd5b80633f4ba83a146102d457806346fbf68e146102dc57600080fd5b806301e647251461026157806317bdbae5146102995780633c4a25d0146102ae5780633d572107146102c1575b600080fd5b61028461026f36600461256e565b600a6020526000908152604090205460ff1681565b60405190151581526020015b60405180910390f35b6102ac6102a73660046125d3565b610616565b005b6102ac6102bc36600461265b565b6107b9565b6102ac6102cf36600461256e565b61081f565b6102ac6108b3565b6102846102ea36600461265b565b6001600160a01b031660009081526001602052604090205460ff1690565b6102ac6103163660046125d3565b61091c565b61033b61032936600461265b565b600c6020526000908152604090205481565b604051908152602001610290565b61033b61035736600461265b565b60086020526000908152604090205481565b6102ac61037736600461256e565b610ab3565b61033b60035481565b600054600160a01b900460ff16610284565b61033b6103a536600461265b565b60046020526000908152604090205481565b6102ac6103c536600461265b565b610b40565b6102ac610ba3565b6102ac610bac565b61033b6103e836600461265b565b600b6020526000908152604090205481565b61028461040836600461265b565b60016020526000908152604090205460ff1681565b6102ac61042b36600461265b565b610c10565b6102ac610c73565b6000546001600160a01b03165b6040516001600160a01b039091168152602001610290565b6102ac61046b36600461256e565b610cda565b6104b261047e36600461256e565b60076020526000908152604090208054600182015460028301546003909301546001600160a01b0392831693919092169184565b604080516001600160a01b039586168152949093166020850152918301526060820152608001610290565b61033b60095481565b61033b6104f436600461265b565b60056020526000908152604090205481565b6102ac6105143660046125d3565b610da7565b6104457f000000000000000000000000000000000000000000000000000000000000000081565b6102ac61054e36600461267d565b610f3e565b6102ac611227565b61028461056936600461265b565b60026020526000908152604090205460ff1681565b61028461058c36600461265b565b6001600160a01b031660009081526002602052604090205460ff1690565b6102ac6105b836600461265b565b611230565b6102ac6105cb36600461265b565b611293565b61033b6105de36600461265b565b60066020526000908152604090205481565b6102ac6105fe3660046126d9565b611372565b6102ac6106113660046125d3565b61177b565b3360009081526002602052604090205460ff166106735760405162461bcd60e51b815260206004820152601660248201527521b0b63632b91034b9903737ba1033b7bb32b93737b960511b60448201526064015b60405180910390fd5b8281146106b45760405162461bcd60e51b815260206004820152600f60248201526e0d8cadccee8d040dad2e6dac2e8c6d608b1b604482015260640161066a565b60005b838110156107b2578282828181106106d1576106d16127c8565b90506020020135600860008787858181106106ee576106ee6127c8565b9050602002016020810190610703919061265b565b6001600160a01b031681526020810191909152604001600020557fceaad6533bfb481492fb3e08ef19297f46611b8fa9de5ef4cf8dc23a56ad09ce858583818110610750576107506127c8565b9050602002016020810190610765919061265b565b848484818110610777576107776127c8565b604080516001600160a01b0390951685526020918202939093013590840152500160405180910390a1806107aa816127f4565b9150506106b7565b5050505050565b6000546001600160a01b031633146108135760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161066a565b61081c81611912565b50565b3360009081526002602052604090205460ff166108775760405162461bcd60e51b815260206004820152601660248201527521b0b63632b91034b9903737ba1033b7bb32b93737b960511b604482015260640161066a565b60098190556040518181527fc0a39f234199b125fb93713c4d067bdcebbf691087f87b79c0feb92b156ba8b6906020015b60405180910390a150565b3360009081526001602052604090205460ff166109125760405162461bcd60e51b815260206004820152601460248201527f43616c6c6572206973206e6f7420706175736572000000000000000000000000604482015260640161066a565b61091a6119cf565b565b3360009081526002602052604090205460ff166109745760405162461bcd60e51b815260206004820152601660248201527521b0b63632b91034b9903737ba1033b7bb32b93737b960511b604482015260640161066a565b8281146109b55760405162461bcd60e51b815260206004820152600f60248201526e0d8cadccee8d040dad2e6dac2e8c6d608b1b604482015260640161066a565b60005b838110156107b2578282828181106109d2576109d26127c8565b90506020020135600560008787858181106109ef576109ef6127c8565b9050602002016020810190610a04919061265b565b6001600160a01b031681526020810191909152604001600020557f608e49c22994f20b5d3496dca088b88dfd81b4a3e8cc3809ea1e10a320107e89858583818110610a5157610a516127c8565b9050602002016020810190610a66919061265b565b848484818110610a7857610a786127c8565b604080516001600160a01b0390951685526020918202939093013590840152500160405180910390a180610aab816127f4565b9150506109b8565b3360009081526002602052604090205460ff16610b0b5760405162461bcd60e51b815260206004820152601660248201527521b0b63632b91034b9903737ba1033b7bb32b93737b960511b604482015260640161066a565b60038190556040518181527f2664fec2ff76486ac58ed087310855b648b15b9d19f3de8529e95f7c46b7d6b3906020016108a8565b6000546001600160a01b03163314610b9a5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161066a565b61081c81611a75565b61091a33611a75565b6000546001600160a01b03163314610c065760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161066a565b61091a6000611b2e565b6000546001600160a01b03163314610c6a5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161066a565b61081c81611b8b565b3360009081526001602052604090205460ff16610cd25760405162461bcd60e51b815260206004820152601460248201527f43616c6c6572206973206e6f7420706175736572000000000000000000000000604482015260640161066a565b61091a611c49565b600054600160a01b900460ff1615610d275760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161066a565b6000610d3282611cd1565b6020810151815160408084015190516340c10f1960e01b81526001600160a01b039283166004820152602481019190915292935016906340c10f1990604401600060405180830381600087803b158015610d8b57600080fd5b505af1158015610d9f573d6000803e3d6000fd5b505050505050565b3360009081526002602052604090205460ff16610dff5760405162461bcd60e51b815260206004820152601660248201527521b0b63632b91034b9903737ba1033b7bb32b93737b960511b604482015260640161066a565b828114610e405760405162461bcd60e51b815260206004820152600f60248201526e0d8cadccee8d040dad2e6dac2e8c6d608b1b604482015260640161066a565b60005b838110156107b257828282818110610e5d57610e5d6127c8565b90506020020135600b6000878785818110610e7a57610e7a6127c8565b9050602002016020810190610e8f919061265b565b6001600160a01b031681526020810191909152604001600020557f3796cd0b17a8734f8da819920625598e9a18be490f686725282e5383f1d06683858583818110610edc57610edc6127c8565b9050602002016020810190610ef1919061265b565b848484818110610f0357610f036127c8565b604080516001600160a01b0390951685526020918202939093013590840152500160405180910390a180610f36816127f4565b915050610e43565b600054600160a01b900460ff1615610f8b5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161066a565b6001600160a01b0384166000908152600b60205260409020548311610ff25760405162461bcd60e51b815260206004820152601060248201527f616d6f756e7420746f6f20736d616c6c00000000000000000000000000000000604482015260640161066a565b6001600160a01b0384166000908152600c6020526040902054158061102f57506001600160a01b0384166000908152600c60205260409020548311155b61107b5760405162461bcd60e51b815260206004820152601060248201527f616d6f756e7420746f6f206c6172676500000000000000000000000000000000604482015260640161066a565b6040516bffffffffffffffffffffffff1933606090811b8216602084015286811b821660348401526048830186905284901b16606882015277ffffffffffffffffffffffffffffffffffffffffffffffff1960c083811b8216607c84015246901b166084820152600090608c0160408051601f1981840301815291815281516020928301206000818152600a90935291205490915060ff16156111505760405162461bcd60e51b815260206004820152600d60248201526c7265636f72642065786973747360981b604482015260640161066a565b6000818152600a602052604090819020805460ff1916600117905551632770a7eb60e21b8152336004820152602481018590526001600160a01b03861690639dc29fac90604401600060405180830381600087803b1580156111b157600080fd5b505af11580156111c5573d6000803e3d6000fd5b5050604080518481526001600160a01b0389811660208301523382840152606082018990528716608082015290517f75f1bf55bb1de41b63a775dc7d4500f01114ee62b688a6b11d34f4692c1f3d4393509081900360a0019150a15050505050565b61091a33611ea3565b6000546001600160a01b0316331461128a5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161066a565b61081c81611ea3565b6000546001600160a01b031633146112ed5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015260640161066a565b6001600160a01b0381166113695760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201527f6464726573730000000000000000000000000000000000000000000000000000606482015260840161066a565b61081c81611b2e565b600054600160a01b900460ff16156113bf5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161066a565b600046306040516020016113fc92919091825260601b6bffffffffffffffffffffffff1916602082015263135a5b9d60e21b603482015260380190565b6040516020818303038152906040528051906020012090507f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663682dbc22828b8b6040516020016114589392919061280f565b6040516020818303038152906040528989898989896040518863ffffffff1660e01b815260040161148f9796959493929190612979565b60006040518083038186803b1580156114a757600080fd5b505afa1580156114bb573d6000803e3d6000fd5b5050505060006115008a8a8080601f016020809104026020016040519081016040528093929190818152602001838380828437600092019190915250611f5c92505050565b6020818101518251604080850151606080870151608088015160a0890151855197841b6bffffffffffffffffffffffff19908116898b015296841b871660348901526048880194909452911b909316606885015260c09290921b77ffffffffffffffffffffffffffffffffffffffffffffffff1916607c8401526084808401929092528051808403909201825260a490920182528051908301206000818152600a9093529120549192509060ff16156115eb5760405162461bcd60e51b815260206004820152600d60248201526c7265636f72642065786973747360981b604482015260640161066a565b6000818152600a602052604090819020805460ff1916600117905582519083015161161691906120be565b81516001600160a01b031660009081526008602052604090205480158015906116425750808360400151115b156116645761165f828460200151856000015186604001516121d6565b6116d4565b8251602084015160408086015190516340c10f1960e01b81526001600160a01b03928316600482015260248101919091529116906340c10f1990604401600060405180830381600087803b1580156116bb57600080fd5b505af11580156116cf573d6000803e3d6000fd5b505050505b7f5bc84ecccfced5bb04bfc7f3efcdbe7f5cd21949ef146811b4d1967fe41f777a8284600001518560200151866040015187608001518860a00151896060015160405161176597969594939291909687526001600160a01b0395861660208801529385166040870152606086019290925267ffffffffffffffff16608085015260a08401521660c082015260e00190565b60405180910390a1505050505050505050505050565b3360009081526002602052604090205460ff166117d35760405162461bcd60e51b815260206004820152601660248201527521b0b63632b91034b9903737ba1033b7bb32b93737b960511b604482015260640161066a565b8281146118145760405162461bcd60e51b815260206004820152600f60248201526e0d8cadccee8d040dad2e6dac2e8c6d608b1b604482015260640161066a565b60005b838110156107b257828282818110611831576118316127c8565b90506020020135600c600087878581811061184e5761184e6127c8565b9050602002016020810190611863919061265b565b6001600160a01b031681526020810191909152604001600020557fa3181379f6db47d9037efc6b6e8e3efe8c55ddb090b4f0512c152f97c4e47da58585838181106118b0576118b06127c8565b90506020020160208101906118c5919061265b565b8484848181106118d7576118d76127c8565b604080516001600160a01b0390951685526020918202939093013590840152500160405180910390a18061190a816127f4565b915050611817565b6001600160a01b03811660009081526002602052604090205460ff161561197b5760405162461bcd60e51b815260206004820152601b60248201527f4163636f756e7420697320616c726561647920676f7665726e6f720000000000604482015260640161066a565b6001600160a01b038116600081815260026020908152604091829020805460ff1916600117905590519182527fdc5a48d79e2e147530ff63ecdbed5a5a66adb9d5cf339384d5d076da197c40b591016108a8565b600054600160a01b900460ff16611a285760405162461bcd60e51b815260206004820152601460248201527f5061757361626c653a206e6f7420706175736564000000000000000000000000604482015260640161066a565b6000805460ff60a01b191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b6001600160a01b03811660009081526001602052604090205460ff16611add5760405162461bcd60e51b815260206004820152601560248201527f4163636f756e74206973206e6f74207061757365720000000000000000000000604482015260640161066a565b6001600160a01b038116600081815260016020908152604091829020805460ff1916905590519182527fcd265ebaf09df2871cc7bd4133404a235ba12eff2041bb89d9c714a2621c7c7e91016108a8565b600080546001600160a01b0383811673ffffffffffffffffffffffffffffffffffffffff19831681178455604051919092169283917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e09190a35050565b6001600160a01b03811660009081526001602052604090205460ff1615611bf45760405162461bcd60e51b815260206004820152601960248201527f4163636f756e7420697320616c72656164792070617573657200000000000000604482015260640161066a565b6001600160a01b038116600081815260016020818152604092839020805460ff191690921790915590519182527f6719d08c1888103bea251a4ed56406bd0c3e69723c8a1686e017e7bbe159b6f891016108a8565b600054600160a01b900460ff1615611c965760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b604482015260640161066a565b6000805460ff60a01b1916600160a01b1790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258611a583390565b604080516080810182526000808252602082018190529181018290526060810191909152600082815260076020908152604091829020825160808101845281546001600160a01b0390811682526001830154169281019290925260028101549282019290925260039091015460608201819052611d905760405162461bcd60e51b815260206004820152601a60248201527f64656c61796564207472616e73666572206e6f74206578697374000000000000604482015260640161066a565b6009548160600151611da29190612a15565b4211611df05760405162461bcd60e51b815260206004820152601d60248201527f64656c61796564207472616e73666572207374696c6c206c6f636b6564000000604482015260640161066a565b6000838152600760209081526040808320805473ffffffffffffffffffffffffffffffffffffffff199081168255600182018054909116905560028101849055600301929092558251908301518383015192517f3b40e5089937425d14cdd96947e5661868357e224af59bd8b24a4b8a330d442693611e9593889390929091909384526001600160a01b03928316602085015291166040830152606082015260800190565b60405180910390a192915050565b6001600160a01b03811660009081526002602052604090205460ff16611f0b5760405162461bcd60e51b815260206004820152601760248201527f4163636f756e74206973206e6f7420676f7665726e6f72000000000000000000604482015260640161066a565b6001600160a01b038116600081815260026020908152604091829020805460ff1916905590519182527f1ebe834e73d60a5fec822c1e1727d34bc79f2ad977ed504581cc1822fe20fb5b91016108a8565b6040805160c08101825260008082526020808301829052828401829052606083018290526080830182905260a0830182905283518085019094528184528301849052909190805b602083015151835110156120b657611fba836122f6565b90925090508160011415611fe957611fd9611fd484612330565b6123ed565b6001600160a01b03168452611fa3565b816002141561201157611ffe611fd484612330565b6001600160a01b03166020850152611fa3565b81600314156120355761202b61202684612330565b6123fe565b6040850152611fa3565b816004141561205d5761204a611fd484612330565b6001600160a01b03166060850152611fa3565b81600514156120835761206f83612435565b67ffffffffffffffff166080850152611fa3565b81600614156120a75761209d61209884612330565b6124b7565b60a0850152611fa3565b6120b183826124cf565b611fa3565b505050919050565b6003546120c9575050565b6001600160a01b038216600090815260056020526040902054806120ec57505050565b6001600160a01b038316600090815260046020526040812054600354909142916121168184612a2d565b6121209190612a4f565b6001600160a01b03871660009081526006602052604090205490915081111561214b57849250612158565b6121558584612a15565b92505b838311156121a85760405162461bcd60e51b815260206004820152601260248201527f766f6c756d652065786365656473206361700000000000000000000000000000604482015260640161066a565b506001600160a01b039094166000908152600460209081526040808320939093556006905220929092555050565b600084815260076020526040902060030154156122355760405162461bcd60e51b815260206004820152601f60248201527f64656c61796564207472616e7366657220616c72656164792065786973747300604482015260640161066a565b604080516080810182526001600160a01b0380861682528481166020808401918252838501868152426060860190815260008b81526007909352918690209451855490851673ffffffffffffffffffffffffffffffffffffffff1991821617865592516001860180549190951693169290921790925551600283015551600390910155517fcbcfffe5102114216a85d3aceb14ad4b81a3935b1b5c468fadf3889eb9c5dce6906122e89086815260200190565b60405180910390a150505050565b600080600061230484612435565b9050612311600882612a2d565b925080600716600581111561232857612328612a6e565b915050915091565b6060600061233d83612435565b905060008184600001516123519190612a15565b905083602001515181111561236557600080fd5b8167ffffffffffffffff81111561237e5761237e612a84565b6040519080825280601f01601f1916602001820160405280156123a8576020820181803683370190505b50602080860151865192955091818601919083010160005b858110156123e25781810151838201526123db602082612a15565b90506123c0565b505050935250919050565b60006123f882612546565b92915050565b600060208251111561240f57600080fd5b60208201519050815160206124249190612a9a565b61242f906008612a4f565b1c919050565b602080820151825181019091015160009182805b600a8110156124b15783811a9150612462816007612a4f565b82607f16901b85179450816080166000141561249f57612483816001612a15565b86518790612492908390612a15565b9052509395945050505050565b806124a9816127f4565b915050612449565b50600080fd5b600081516020146124c757600080fd5b506020015190565b60008160058111156124e3576124e3612a6e565b14156124f7576124f282612435565b505050565b600281600581111561250b5761250b612a6e565b141561025c57600061251c83612435565b905080836000018181516125309190612a15565b905250602083015151835111156124f257600080fd5b6000815160141461255657600080fd5b50602001516c01000000000000000000000000900490565b60006020828403121561258057600080fd5b5035919050565b60008083601f84011261259957600080fd5b50813567ffffffffffffffff8111156125b157600080fd5b6020830191508360208260051b85010111156125cc57600080fd5b9250929050565b600080600080604085870312156125e957600080fd5b843567ffffffffffffffff8082111561260157600080fd5b61260d88838901612587565b9096509450602087013591508082111561262657600080fd5b5061263387828801612587565b95989497509550505050565b80356001600160a01b038116811461265657600080fd5b919050565b60006020828403121561266d57600080fd5b6126768261263f565b9392505050565b6000806000806080858703121561269357600080fd5b61269c8561263f565b9350602085013592506126b16040860161263f565b9150606085013567ffffffffffffffff811681146126ce57600080fd5b939692955090935050565b6000806000806000806000806080898b0312156126f557600080fd5b883567ffffffffffffffff8082111561270d57600080fd5b818b0191508b601f83011261272157600080fd5b81358181111561273057600080fd5b8c602082850101111561274257600080fd5b60209283019a509850908a0135908082111561275d57600080fd5b6127698c838d01612587565b909850965060408b013591508082111561278257600080fd5b61278e8c838d01612587565b909650945060608b01359150808211156127a757600080fd5b506127b48b828c01612587565b999c989b5096995094979396929594505050565b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052601160045260246000fd5b6000600019821415612808576128086127de565b5060010190565b838152818360208301376000910160200190815292915050565b81835281816020850137506000828201602090810191909152601f909101601f19169091010190565b81835260006020808501808196508560051b810191508460005b878110156128d65782840389528135601e1988360301811261288d57600080fd5b8701803567ffffffffffffffff8111156128a657600080fd5b8036038913156128b557600080fd5b6128c28682898501612829565b9a87019a955050509084019060010161286c565b5091979650505050505050565b8183526000602080850194508260005b8581101561291f576001600160a01b0361290c8361263f565b16875295820195908201906001016128f3565b509495945050505050565b81835260007f07ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff83111561295c57600080fd5b8260051b8083602087013760009401602001938452509192915050565b608081526000885180608084015260005b818110156129a7576020818c0181015160a086840101520161298a565b818111156129b957600060a083860101525b50601f01601f1916820182810360a090810160208501526129dd908201898b612852565b905082810360408401526129f28187896128e3565b90508281036060840152612a0781858761292a565b9a9950505050505050505050565b60008219821115612a2857612a286127de565b500190565b600082612a4a57634e487b7160e01b600052601260045260246000fd5b500490565b6000816000190483118215151615612a6957612a696127de565b500290565b634e487b7160e01b600052602160045260246000fd5b634e487b7160e01b600052604160045260246000fd5b600082821015612aac57612aac6127de565b50039056fea2646970667358221220b55f63fdf6b09ff1648015391f9d956ec1c39ac2d1500c95abe7f62a545d573764736f6c63430008090033";

type PeggedTokenBridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: PeggedTokenBridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class PeggedTokenBridge__factory extends ContractFactory {
  constructor(...args: PeggedTokenBridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "PeggedTokenBridge";
  }

  deploy(
    _sigsVerifier: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): Promise<PeggedTokenBridge> {
    return super.deploy(_sigsVerifier, overrides || {}) as Promise<PeggedTokenBridge>;
  }
  getDeployTransaction(
    _sigsVerifier: string,
    overrides?: Overrides & { from?: string | Promise<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_sigsVerifier, overrides || {});
  }
  attach(address: string): PeggedTokenBridge {
    return super.attach(address) as PeggedTokenBridge;
  }
  connect(signer: Signer): PeggedTokenBridge__factory {
    return super.connect(signer) as PeggedTokenBridge__factory;
  }
  static readonly contractName: "PeggedTokenBridge";
  public readonly contractName: "PeggedTokenBridge";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PeggedTokenBridgeInterface {
    return new utils.Interface(_abi) as PeggedTokenBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): PeggedTokenBridge {
    return new Contract(address, _abi, signerOrProvider) as PeggedTokenBridge;
  }
}
